import moment from 'moment';
import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getFAICurrentInspection } from './getFAICurrentInspection';

/**
 * Reference instant for FAI elapsed-time tickers (header, banner): pending uses
 * when the operator requested inspection; in progress uses when the inspector
 * started; approved/rejected use when the evaluation was recorded.
 */
export const getFAICurrentInspectionElapsedSince = createSelector(
  [getFAICurrentInspection],
  (currentInspection) => {
    if (!currentInspection) {
      return null;
    }
    const { status, requestedAt, startedAt, evaluatedAt } = currentInspection;
    if (status === FAI_STATUS.PENDING) {
      return requestedAt ? moment(requestedAt) : null;
    }
    if (status === FAI_STATUS.IN_PROGRESS) {
      return startedAt ? moment(startedAt) : null;
    }
    if (status === FAI_STATUS.REJECTED || status === FAI_STATUS.APPROVED) {
      return evaluatedAt ? moment(evaluatedAt) : null;
    }
    return null;
  }
);
